export default function(num, point){
    // 将数字转换为字符串,然后通过split方法用.分隔,取到第0个
    let numStr = num.toString().split('.')[0];
    point = point || '1';
    if(numStr.length<5) { // 判断数字有多长,如果小于5,表示1万以内的数字,让其直接显示
        return numStr;
    }else if(numStr.length>=5){ // 如果数字大于5位,让其数字后面加单位w
        // 由千位,百位组成的一个数字
        return parseFloat(numStr / 10000).toFixed(point)+'万'
    }
}